import { Field, Int, ObjectType } from "@nestjs/graphql";

@ObjectType()
export class EntityDeletionSummaryDto {
  @Field()
  dtoTypeName!: string

  @Field(t => Int)
  count!: number

  @Field(t => [Int], { nullable: true })
  ids!: number[]
}
